import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { UiButton } from '@shared/components/ui-button/ui-button';
import { NotificationService } from '@shared/services/notification';

@Component({
  selector: 'app-notification-overlay',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, UiButton],
  templateUrl: './notification-overlay.html',
  styleUrl: './notification-overlay.css'
})
export class NotificationOverlay {
  protected readonly notify = inject(NotificationService);

  protected readonly isVisible = this.notify.isVisible;
  protected readonly message = this.notify.message;
  protected readonly type = this.notify.type;
  protected readonly buttons = this.notify.buttons;

  protected getTitle(): string {
    switch (this.type()) {
      case 'success': return 'Éxito';
      case 'error': return 'Error';
      case 'warning': return 'Advertencia';
      case 'info': return 'Información';
    }
  }

  protected getIcon(): string {
    switch (this.type()) {
      case 'success': return 'check-circle';
      case 'error': return 'triangle-alert';
      case 'warning': return 'triangle-alert';
      case 'info': return 'info';
    }
  }

  protected getColorClasses(): { bg: string; text: string; icon: string } {
    switch (this.type()) {
      case 'success': return { bg: 'bg-green-100', text: 'text-green-700', icon: 'text-green-600' };
      case 'error': return { bg: 'bg-red-100', text: 'text-red-700', icon: 'text-red-600' };
      case 'warning': return { bg: 'bg-amber-100', text: 'text-amber-700', icon: 'text-amber-600' };
      case 'info': return { bg: 'bg-blue-100', text: 'text-blue-700', icon: 'text-blue-600' };
    }
  }
}
